import { FEATURE_NAMES } from '../../loaders/features/features';
export const FEATURE_NAME = FEATURE_NAMES.jserrors;
export const NR_ERR_PROP = 'nr@seenError';